var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.projectLoaded)?_c('v-krpano-viewer',{attrs:{"project":_vm.project,"API":_vm.API,"pwa":""},on:{"update:project":function($event){_vm.project=$event}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }